import type { SignalForm } from "@owanturist/signal-form";
import { useHandler } from "@suse-o11y/use-handler";
import { type RefObject, useEffect, useRef } from "react";

export function useOnInvalidFormFocus<TRef extends { focus: VoidFunction }>(
	form: undefined | SignalForm,
	onFocus?: (ref: TRef) => void,
): RefObject<TRef> {
	const ref = useRef<TRef>(null);
	const onFocusStable = useHandler(onFocus);

	useEffect(() => {
		const target = ref.current;

		if (form != null && target != null) {
			return form.onFocusWhenInvalid(() => {
				target.focus();
				onFocusStable?.(target);
			});
		}
	}, [form, onFocusStable]);

	return ref;
}
